module.exports = {"receivedInvitationsTitle":"Received Invitations","sentInvitationsTitle":"Sent Invitations","recipientColumnHeading":"Recipient","senderColumnHeading":"Sender","actions":{"accept":"Accept","reject":"Reject","cancel":"Cancel"},"status":{"accepted":"Accepted","rejected":"Rejected","cancelled":"Cancelled"},"meta":"Invitations"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/invitations.json
// module id = AKZj
// module chunks = 1